import React, { useState } from "react";
import "./Equi2.css";
import { Container, Row, Col, Card, CardBody, CardHeader } from "reactstrap";
import { Link } from "react-router-dom";

const Equip2 = () => {

   const [alarms4]  = useState([]);
    const [alarms5]  = useState([]);
    const [alarms6]  = useState([]);
    const [alarms7]  = useState([]);
    const [alarms8]  = useState([]);
    const [alarms9]  = useState([]);
    const [alarms10] = useState([]);
    const [alarms11] = useState([]);
    const [alarms12] = useState([]);
    const [alarms13] = useState([]);
    const [alarms14] = useState([]);
    const [alarms15] = useState([]);
    const [alarms16] = useState([]);
    const [alarms17] = useState([]);
    const [alarms18] = useState([]);
    const [alarms19] = useState([]);
    const EXH_TEMP = ["605 °C", "613 °C", "613 °C", "612 °C", "619 °C", "624 °C"];
const EXH_DEV  = [7, 1, 1, 1, 7, 11];
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Card className="em-card">

            {/* ── HEADER ── */}
            <CardHeader className="em-header">
              {/* <div className="em-header-left"> */}
               
                {/* <div className="em-ship-info">
                  <span className="em-ship-name">ARK Prestige</span>
                  <span className="em-ship-sub">IMO 9665671</span>
                </div> */}
                 {/* <div className="em-ship-info">
                  <span className="em-ship-name">Equipment Overview</span> */}
                  {/* <span className="em-ship-sub">IMO 9665671</span> */}
                {/* </div>
              </div> */}

              <div className="em-header-left">
  <div className="em-ship-info">
    <span className="em-ship-name">Equipment Overview</span>
    {/* Vessel Dropdown */}
</div>
    <div className="em-vessel-dropdown-wrapper">
      <select className="em-vessel-dropdown">
        <option value="ark-prestige">ARK Prestige</option>
        <option value="vessel1">Vessel 1</option>
        <option value="vessel2">Vessel 2</option>
        <option value="vessel3">Vessel 3</option>
        <option value="vessel4">Vessel 4</option>
      </select>
      <span className="em-vessel-arrow">▾</span>
    </div>
  </div>

              <div className="em-nav">
                <button className="em-nb em-nb-active"><Link to="/equip2">Main Engine</Link></button>
                <button className="em-nb"><Link to="/auxiliaryEngine1">Auxilary Engine </Link></button>
                <button className="em-nb"><Link to="/alerts">Alerts</Link></button>
                <button className="em-nb"><Link to="/alarms">Alarms</Link></button>
                      <button className="em-nb"><Link to="/monitor">Cargo</Link></button>
                <button className="em-nb">CCTV</button>
                <button className="em-nb">Status</button>
                <button className="em-nb">Master</button>
                <button className="em-nb">User</button>
                <span className="em-badge em-badge-red">10</span>
                <span className="em-badge em-badge-yellow">19</span>
                  <span className="em-ship-sub">UTC : 03:36:16</span>
              </div>
            </CardHeader>

            <CardBody className="em-body">

             

              <Row className="g-2">

                {/* ── LEFT: Info panels ── */}
                <Col lg={2}>
                  <div className="em-right-col">

                    {/* Turbo Charger */}
                    <div className="em-glass em-panel">
                      <div className="em-sec-label-full">TURBO CHARGER</div>
                      {[
                        ["T/C RPM NO.1",       "7565", "RPM"],
                        ["T/C RPM NO.2",       "7324", "RPM"],
                        ["T/C EXH GAS IN NO.1","277",  "°C" ],
                        ["T/C EXH GAS IN NO.2","223",  "°C" ],
                      ].map(([l,v,u],i) => (
                        <div key={i} className="em-sensor-row">
                          <span className="em-s-label">{l}</span>
                          <div className="em-s-val-group">
                            <span className="em-s-val">{v}</span>
                            <span className="em-s-unit">{u}</span>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* LO */}
                    <div className="em-glass em-panel">
                      <div className="em-sec-label-full">LO</div>
                      {[
                        ["T/C LO PRESS NO.1","1.7", "BAR"],
                        ["T/C LO TEMP NO.1", "55",  "°C" ],
                        ["T/C LO TEMP NO.2", "56",  "°C" ],
                      ].map(([l,v,u],i) => (
                        <div key={i} className="em-sensor-row">
                          <span className="em-s-label">{l}</span>
                          <div className="em-s-val-group">
                            <span className="em-s-val">{v}</span>
                            <span className="em-s-unit">{u}</span>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* FO Inlet */}
                    <div className="em-glass em-panel">
                      <div className="em-sec-label-full">FO INLET</div>
                      {[
                        ["F.O Inlet Press",    "8.0",  "BAR"],
                        ["Main LO In Press",   "4.5",  "BAR"],
                        ["Water in Oil High",  "0.12", "AW" ],
                      ].map(([l,v,u],i) => (
                        <div key={i} className="em-sensor-row">
                          <span className="em-s-label">{l}</span>
                          <div className="em-s-val-group">
                            <span className="em-s-val">{v}</span>
                            <span className="em-s-unit">{u}</span>
                          </div>
                        </div>
                      ))}
                    </div>

                  </div>
                </Col>
                 <Col lg={2}>
                  <div className="em-right-col">

                    {/* Turbo Charger */}
                    <div className="em-glass em-panel">
                      <div className="em-sec-label-full">SHIP OVERALL EFFICIENCY</div>
                      {[
                        ["ACTUAL",       "7565", "RPM"],
                        ["COR",       "7324", "RPM"],
                        ["SPECIFIC FUEL RATE",  "°C" ],
                    
                      ].map(([l,v,u],i) => (
                        <div key={i} className="em-sensor-row">
                          <span className="em-s-label">{l}</span>
                          <div className="em-s-val-group">
                            <span className="em-s-val">{v}</span>
                            <span className="em-s-unit">{u}</span>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* LO */}
                    <div className="em-glass em-panel">
                      <div className="em-sec-label-full">SHAFT POWER SYSTEM</div>
                      {[
                        ["Torque","1.7", "BAR"],
                        ["Power","5288", "kW"],
                        ["Revolutions","46.0", "RPM"],
                      ].map(([l,v,u],i) => (
                        <div key={i} className="em-sensor-row">
                          <span className="em-s-label">{l}</span>
                          <div className="em-s-val-group">
                            <span className="em-s-val">{v}</span>
                            <span className="em-s-unit">{u}</span>
                          </div>
                        </div>
                      ))}
                    </div>

                    {/* FO Inlet */}
                    <div className="em-glass em-panel">
                      <div className="em-sec-label-full">SCAV AIR RECEIVER</div>
                      {[
                        ["Temp",    "38",  "°C"],
                        ["Inlet Press",   "0.4",  "BAR"],
                        ["Starting Air Press",  "26.6", "BAR" ],
                      ].map(([l,v,u],i) => (
                        <div key={i} className="em-sensor-row">
                          <span className="em-s-label">{l}</span>
                          <div className="em-s-val-group">
                            <span className="em-s-val">{v}</span>
                            <span className="em-s-unit">{u}</span>
                          </div>
                        </div>
                      ))}
                    </div>
 <div className="em-glass em-panel">
                      <div className="em-sec-label-full">FUEL / EFFICIENCY</div>
                      {[
                        ["F.O In Temp",    "38",  "°C"],
                        ["Propulsion Eff.",   "0.4",  "BAR"],
                        ["Fuel Consumption",  "26.6", "BAR" ],
                      ].map(([l,v,u],i) => (
                        <div key={i} className="em-sensor-row">
                          <span className="em-s-label">{l}</span>
                          <div className="em-s-val-group">
                            <span className="em-s-val">{v}</span>
                            <span className="em-s-unit">{u}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </Col>
 {/* Bottom data cards */}
                    {/* <Row className="g-2">
                      {[
                        {
                          title: "SHIP OVERALL EFFICIENCY",
                          rows: [["ACTUAL","0",""],["COR","0",""],["SPECIFIC FUEL RATE","0","g/kWh"]],
                        },
                        {
                          title: "SHAFT POWER SYSTEM",
                          rows: [["Torque","1102","kNm"],["Power","5288","kW"],["Revolutions","46.0","RPM"]],
                        },
                        {
                          title: "SCAV AIR RECEIVER",
                          rows: [["Temp","38","°C"],["Inlet Press","0.4","BAR"],["Starting Air Press","26.6","BAR"]],
                        },
                        {
                          title: "FUEL / EFFICIENCY",
                          rows: [["F.O In Temp","30","°C"],["Propulsion Eff.","3.5","mj/kWh"],["Fuel Consumption","0","kg/hr"]],
                        },
                      ].map((card, ci) => (
                        <Col key={ci} lg={3} md={6}>
                          <div className="em-glass em-panel">
                            <div className="em-sec-label-full">{card.title}</div>
                            {card.rows.map(([l,v,u],i) => (
                              <div key={i} className="em-sensor-row">
                                <span className="em-s-label">{l}</span>
                                <div className="em-s-val-group">
                                  <span className="em-s-val">{v}</span>
                                  {u && <span className="em-s-unit">{u}</span>}
                                </div>
                              </div>
                            ))}
                          </div>
                        </Col>
                      ))}
                    </Row> */}
                {/* ── MIDDLE: Cylinder exhaust temps ── */}
                {/* <Col lg={2}>
                  <div className="em-glass em-panel em-panel-scroll">
                   
                    {[
                      ["CYL NO.1","242","°C"],
                      ["CYL NO.2","238","°C"],
                      ["CYL NO.3","251","°C"],
                      ["CYL NO.4","245","°C"],
                      ["CYL NO.5","239","°C"],
                      ["CYL NO.6","248","°C"],
                      ["CYL NO.7","253","°C"],
                      ["CYL NO.8","241","°C"],
                      ["CYL NO.9","244","°C"],
                    ].map(([l,v,u],i) => (
                       <div key={i} className="em-sec-label-full">ME CYLINDER EXH GAS
                      <div  className="em-sensor-row">
                        
                        <span className="em-s-label">{l}</span>
                        <div className="em-s-val-group">
                          <span className="em-s-val">{v}</span>
                          <span className="em-s-unit">{u}</span>
                        </div>
                      </div></div>
                    ))}
                  </div>
                </Col> */}

                {/* ── RIGHT: Engine image + bottom data ── */}
                <Col lg={8}>
                 {/* ── STATUS BAR ── */}
              <div className="em-status-bar em-glass mb-2">
                <span className="em-status-badge em-status-green">NO.1 AUX BLOWER RUN</span>
                <span className="em-status-badge em-status-green">NO.2 AUX BLOWER RUN</span>
                <span className="em-status-badge em-status-blue">EXH. MEAN: 240°C</span>
                <span className="em-status-badge em-status-blue">SHIP SPEED: 14.7 Knots</span>
              </div>
                  <div className="em-right-col">

                    {/* Engine image
                    <div className="em-glass em-engine-section">
                      <img
                        src="/asset/compressorimage.png"
                        alt="Engine"
                        className="em-engine-img"
                      />
                    </div> */}

{/* Engine video */}
<div className="em-glass em-engine-section">
  <video
    src="/asset/Create_a_photorealistic_mechan.mp4"
    className="em-engine-img"
    autoPlay
    loop
    muted
    playsInline
  />
</div>


                    {/* Bottom data cards */}
                    {/* <Row className="g-2">
                      {[
                        {
                          title: "SHIP OVERALL EFFICIENCY",
                          rows: [["ACTUAL","0",""],["COR","0",""],["SPECIFIC FUEL RATE","0","g/kWh"]],
                        },
                        {
                          title: "SHAFT POWER SYSTEM",
                          rows: [["Torque","1102","kNm"],["Power","5288","kW"],["Revolutions","46.0","RPM"]],
                        },
                        {
                          title: "SCAV AIR RECEIVER",
                          rows: [["Temp","38","°C"],["Inlet Press","0.4","BAR"],["Starting Air Press","26.6","BAR"]],
                        },
                        {
                          title: "FUEL / EFFICIENCY",
                          rows: [["F.O In Temp","30","°C"],["Propulsion Eff.","3.5","mj/kWh"],["Fuel Consumption","0","kg/hr"]],
                        },
                      ].map((card, ci) => (
                        <Col key={ci} lg={3} md={6}>
                          <div className="em-glass em-panel">
                            <div className="em-sec-label-full">{card.title}</div>
                            {card.rows.map(([l,v,u],i) => (
                              <div key={i} className="em-sensor-row">
                                <span className="em-s-label">{l}</span>
                                <div className="em-s-val-group">
                                  <span className="em-s-val">{v}</span>
                                  {u && <span className="em-s-unit">{u}</span>}
                                </div>
                              </div>
                            ))}
                          </div>
                        </Col>
                      ))}
                    </Row> */}
  <div className="em-exh-right">
                        <div className="em-exh-title">ME CYLINDER EXH GAS</div>
                        {/* <div className="em-exh-title">ME CYLINDER EXH GAS</div> */}
                        <div className="em-exh-grid">
                          {["NO.1","NO.2","NO.3","NO.4","NO.5","NO.6"].map((h,i) => (
                            <div key={i} className="em-exh-head">{h}</div>
                          ))}
                          {[alarms8,alarms9,alarms10,alarms11,alarms12,alarms13].map((arr, i) => (
                            <div key={i} className="em-exh-val">
                              {arr.length ? arr.map((it,j) => <span key={j}>{it.min_value} </span>) : EXH_TEMP[i] }
                            </div>
                          ))}
                          {/* {[alarms14,alarms15,alarms16,alarms17,alarms18,alarms19].map((arr, i) => (
                            <div key={i} className="em-exh-dev">
                              {arr.length ? arr.map((it,j) => <span key={j}>{it.min_value}</span>) : `+${EXH_DEV[i]}`}
                            </div>
                          ))} */}
                        </div>
                      </div>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Equip2;